// extracted by mini-css-extract-plugin
export default {"descriptionWrapper":"BankStatement_descriptionWrapper__gE3KN"};